export const teamsMemberActions = {
  FETCH_TEAM_MEMBERS_FAILED: 'FETCH_TEAM_MEMBERS_FAILED',
  FETCH_TEAM_MEMBERS_SUCCESS: 'FETCH_TEAM_MEMBERS_SUCCESS',
  FETCH_TEAM_MEMBERS_PENDING: 'FETCH_TEAM_MEMBERS_PENDING',

  FETCH_TEAM_MEMBER_BY_ID: 'FETCH_TEAM_MEMBER_BY_ID',
  
  fetchTeamMembersFailed: error => ({
    type: teamsMemberActions.FETCH_TEAM_MEMBERS_FAILED,
    payload: error
  }),

  fetchTeamMembersSuccess: (teamsMemberId, data) => ({
    type: teamsMemberActions.FETCH_TEAM_MEMBERS_SUCCESS,
    payload: {
      data,
      teamsMemberId
    }
  }),

  fetchTeamMembersPending: teamsMemberId => ({
    type: teamsMemberActions.FETCH_TEAM_MEMBERS_PENDING,
    payload: {
      teamsMemberId
    }
  }),

  fetchTeamMemberById: ({ teamsMemberId, teamId }) => ({
    type: teamsMemberActions.FETCH_TEAM_MEMBER_BY_ID,
    payload: {
      teamsMemberId,
      teamId
    }
  })
};

export const teamsMemberRequestActions = {
  failed: teamsMemberActions.fetchTeamMembersFailed,
  success: teamsMemberActions.fetchTeamMembersSuccess,
  pending: teamsMemberActions.fetchTeamMembersPending
};